/**
 * A MODULE'S ID IS NOT ITS NAME.
 *
 * The ids are keys: route segments, folder names, audit sources, pool ids.
 * They never move. What staff see is the label, which lives in the message
 * table under `vocab.module.<id>` and `vocab.moduleShort.<id>`.
 */
export const MODULE_IDS = ["counter", "psp", "cpms"] as const;
export type ModuleId = (typeof MODULE_IDS)[number];

export function isModuleId(value: unknown): value is ModuleId {
  return typeof value === "string" && (MODULE_IDS as readonly string[]).includes(value);
}

/** The module a branch runs when it runs exactly one, else undefined. Unknown enrolment is never "sole". */
export function soleModuleOf(modules: readonly ModuleId[] | undefined): ModuleId | undefined {
  return modules && modules.length === 1 ? modules[0] : undefined;
}
